<script lang="ts">
  import { Col, Container, Image, Row } from "sveltestrap";
  import RegisterLoginForm from "./RegisterLoginForm.svelte";
  let imgPath: string = "/assets/images/login";
</script>

<section>
  <Container fluid class="p-0">
    <Row class="m-0">
      <Col xl="7" class="p-0">
        <Image
          class="bg-img-cover bg-center"
          src="{imgPath}/1.jpg"
          alt="looginpage"
        />
      </Col>
      <Col xl="5" class="p-0">
        <div class="login-card">
          <RegisterLoginForm />
        </div>
      </Col>
    </Row>
  </Container>
</section>
